import apiClient from './apiClient';

/**
 * Get all size guides
 * @returns {Promise<Array>} Array of size guides
 */
export const getSizeGuides = async () => {
  try {
    const response = await apiClient.get('/size-guides');
    return response.data;
  } catch (error) {
    console.error('Error fetching size guides:', error);
    throw error;
  }
};

/**
 * Get size guide by ID
 * @param {string} sizeGuideId - Size guide ID
 * @returns {Promise<Object>} Size guide
 */
export const getSizeGuideById = async (sizeGuideId) => {
  try {
    const response = await apiClient.get(`/size-guides/${sizeGuideId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching size guide:', error);
    throw error;
  }
};
